import { analytics } from '@/features/analytics/events'
import { useEffect, useRef } from 'react'
import type { RecordingQuality } from './useAudioRecorder'

export function useRecordingQualityAnalytics(projectId: string, quality: RecordingQuality | null) {
  const lastRef = useRef<RecordingQuality | null>(null)
  useEffect(() => {
    if (!quality || quality === lastRef.current) return
    lastRef.current = quality
    const issue = quality.result.issue
    if (!issue) return
    if (quality.blocked) analytics.recordingQualityBlocked(projectId, issue)
    else analytics.recordingQualityWarned(projectId, issue)
  }, [quality, projectId])
}
